// extracted by mini-css-extract-plugin
module.exports = {"left":"ReportForm_left__3OIIX","right":"ReportForm_right__3gJTk","detailButton":"ReportForm_detailButton__2iBXb","box":"ReportForm_box__1OFjV"};